import React from 'react';
import { componentService } from 'js/services/component.service';

export const FundTransfer = React.lazy(() => import(/* webpackChunkName: "fund-transfer" */ './FundTransfer'));

componentService.registerPageComponents({ 'fund-transfer': FundTransfer });
